import React, { useEffect, useMemo, useState } from 'react';
import { StyleSheet, Image, useWindowDimensions } from 'react-native';
import { Col, Row, useDynamicResponsiveValue, Text, Scroll, Img } from 'react-quick-style-components';
import { useNavFunc } from 'navigation';
import { IScreen } from 'type';
import { ASSETS, ICON, DEVICE_INFO, COLOR, fSize, STYLES } from 'const';
import { Footer, Header, ChatBox, LiquidEffect, StaticCask, Card, TableWithAction } from "components"
import Store from 'store';
import { VarHelper } from 'helpers';

const Casks: IScreen = () => {
  const { width, height } = useWindowDimensions();
  const rV = useDynamicResponsiveValue();
  const [page, setPage] = useState<'single-cask' | 'multiple-cask'>('single-cask');
  const [{ listClients, listAvailableCasks }, cApi] = Store.Client.createStore();
  const [{ email }] = Store.User.createStore();
  const [showAvailableCask, setShowAvailableCask] = useState(false);
  const [{ }, mApi] = Store.Message.createStore();

  useEffect(() => {
    if (listClients.length === 0) cApi.getListClients();
    cApi.getListAvailableCasks();
  }, []);

  const { caskHeight, caskWidth, spacer } = (() => {
    if (width >= 1000) {
      if (height >= 1080) return {
        caskHeight: height * 0.25, caskWidth: height * 0.25 * 577 / 740,
        spacer: { top: height * 0.05, middle: 70, bottom: 30 },
      }
      if (height >= 950) return {
        caskHeight: height * 0.25, caskWidth: height * 0.25 * 577 / 740,
        spacer: { top: height * 0.05, middle: 30, bottom: 30 },
      }
      if (height >= 900) return {
        caskHeight: height * 0.25, caskWidth: height * 0.25 * 577 / 740,
        spacer: { top: height * 0.03, middle: 30, bottom: 30 },
      }
      if (height >= 800) return {
        caskHeight: height * 0.20, caskWidth: height * 0.20 * 577 / 740,
        spacer: { top: height * 0.06, middle: 0, bottom: 20 },
      }
      if (height >= 768) return {
        caskHeight: height * 0.20, caskWidth: height * 0.20 * 577 / 740,
        spacer: { top: height * 0.025, middle: 0, bottom: 20 },
      }
      if (height >= 650) return {
        caskHeight: height * 0.15, caskWidth: height * 0.15 * 577 / 740,
        spacer: { top: 10, middle: 0, bottom: 10 },
      }
    }

    else if (width < 1000) {
      if (width >= 700) return {
        caskHeight: width * 0.15 * 740 / 577, caskWidth: width * 0.15,
        spacer: { top: height * 0.35, middle: 0, bottom: 10 },
      }
      if (width <= 480) return {
        caskHeight: width * 0.12 * 740 / 577, caskWidth: width * 0.12,
        spacer: { top: height < 700 ? height * 0.15 : height * 0.2, middle: height < 700 ? height * 0.1 : height * 0.15, bottom: 10 },
      }
    }
    return {
      caskHeight: height * 0.15, caskWidth: height * 0.15 * 577 / 740,
      spacer: { top: 10, middle: 0, bottom: 10 },
    }
  })();



  const { portfolioValue } = (() => {
    if (listClients.length === 0 || !email) return { portfolioValue: 0 };
    const filterClient = listClients.filter(val => val.Email === email);
    // console.log('filterClient', filterClient);
    // if (filterClient.length > 0) return {
    //   portfolioValue: +filterClient[0]['Portfolio'],
    // }
    if (filterClient.length > 0) return filterClient.reduce((acc, val) => {
      return {
        portfolioValue: acc.portfolioValue + +val['Portfolio'],
      }
    }, { portfolioValue: 0 });
    return {
      portfolioValue: 0,
    };
  })();

  const comission = [
    { displayValue: 10, name: 'Barrel', range: [0, 25000] },
    { displayValue: 8.5, name: 'Hogshead', range: [25001, 100000] },
    { displayValue: 7, name: 'Butt', range: [100001, 250000] },
    { displayValue: 5.5, name: 'Puncheon', range: [250001, Infinity] },
  ];

  const { myCommision, nextCommision, myIndex } = (() => {
    let myIndex = 0;
    for (let i = 0; i < comission.length; i++) {
      if (comission[i].range[0] < portfolioValue && comission[i].range[1] > portfolioValue) {
        myIndex = i;
        break;
      }
    }
    return {
      myIndex,
      myCommision: comission[myIndex],
      nextCommision: myIndex === comission.length - 1 ? null : comission[myIndex + 1],
    };
  })();

  const myAM = listClients.length > 0 ? listClients[0]['Account Manager'] : '';

  const messageAdmin = async (item) => {
    console.log('item', item);
    console.log('myAM', myAM);
    // { Region: 'Highlands', Cask Type: 'Barel', Age: 5, Price: '5-10' }
    const [res, err] = await mApi.sendMessage({
      subject: 'Request cask info',
      from: email,
      message: `${name} (${email}) has requested info about this cask: Region ${item.Region} | type ${item['Cask Type']} | Age ${item.Age} | Price ${item.Price}`,
      am: myAM,
    });
    alert('Thank you, your request has been sent');
  }

  const renderSingleCask = () => {
    if (listClients.length === 0 || !email) return null;
    const targetPercentage = myCommision.range[1] === Infinity ? 1 : (portfolioValue - myCommision.range[0]) / (myCommision.range[1] - myCommision.range[0])
    console.log('targetPercentage', targetPercentage);
    const ratio = 1.15;
    const thisCaskWidth = caskWidth * ratio;
    const thisCaskHeight = caskHeight * ratio;
    const circleSize = rV({ xs: 30, md: 70 });
    const val = comission[myIndex];
    return (
      <Row onPress={() => setPage('multiple-cask')} alignItems="flex-end" justifyContent='center'>
        <Col middle>
          <Col marginTop20 width={circleSize} height={circleSize} borderRadius={circleSize / 2} backgroundColor={"#A37A49"} middle>
            <Text colorWhite bold fontSize={rV({ xs: 10, md: 20 })}>{val.displayValue}%</Text>
          </Col>
          <Text colorWhite marginTop10 bold fontSize={rV({ xs: 10, md: 20 })}>{val.name.toUpperCase()}</Text>
          <Col margin20 width={thisCaskWidth} height={thisCaskHeight}>
            <LiquidEffect
              width={thisCaskWidth} height={thisCaskHeight} mask={ASSETS.ONECASK}
              percent={targetPercentage}
            />
          </Col>
        </Col>
      </Row>
    );
  }

  const renderMultipleCasks = () => {
    if (listClients.length === 0 || !email) return null;
    const targetPercentage = myCommision.range[1] === Infinity ? 1 : (portfolioValue - myCommision.range[0]) / (myCommision.range[1] - myCommision.range[0])
    console.log('targetPercentage', targetPercentage);
    return (
      <Row onPress={() => setPage('single-cask')} style={{ flexWrap: 'wrap' }} key={'percent-' + targetPercentage} alignItems="flex-end">
        {comission.map((val, i) => {
          const ratio = [0.7, 0.85, 1, 1.15][i];
          const thisCaskWidth = caskWidth * ratio;
          const thisCaskHeight = caskHeight * ratio;
          const circleSize = rV({ xs: 30, md: 70 });
          return (
            <Col middle marginHorizontal={rV({ xs: 0, md: 10 })} key={'cask-' + i}>
              <Col marginTop20 width={circleSize} height={circleSize} borderRadius={circleSize / 2} backgroundColor={"#A37A49"} middle>
                <Text colorWhite bold fontSize={rV({ xs: 10, md: 20 })}>{val.displayValue}%</Text>
              </Col>
              <Text colorWhite marginTop10 bold fontSize={rV({ xs: 10, md: 20 })}>{val.name.toUpperCase()}</Text>
              {width > 480 && (
                !Boolean(val.range[1] > 1000000000000000000) ? (
                  <Col marginTop10><Text bold colorWhite>{VarHelper.money(val.range[0])} - {VarHelper.money(val.range[1])}</Text></Col>
                ) : (
                  <Col marginTop10><Text bold colorWhite>{VarHelper.money(val.range[0])} +</Text></Col>
                )
              )}
              <Col margin20 width={thisCaskWidth} height={thisCaskHeight}>
                {i === myIndex ? (
                  <LiquidEffect
                    width={thisCaskWidth} height={thisCaskHeight} mask={ASSETS.ONECASK}
                    percent={targetPercentage}
                  />
                ) : (
                  <StaticCask
                    width={thisCaskWidth} height={thisCaskHeight} mask={ASSETS.ONECASK}
                    percent={i < myIndex ? 1 : 0}
                  />
                )}
              </Col>
            </Col>
          );
        })}
      </Row>
    );
  }
  const modalSize = Math.min(width, height) * 0.9;


  return (
    <Col flex1 backgroundColor={COLOR.BG}>
      <>
        <Header />
        <Col style={{ flex: 1 }}>
          <Col flex1>
            <Col absoluteFill>
              {/* <Img source={ASSETS.CASK_BG} style={STYLES.all100p} imageProps={{ resizeMode:"cover" }} /> */}
              <img src={ASSETS.CASK_BG} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'bottom' }} />
            </Col>
            <Col absoluteFill alignItems="center" backgroundColor="rgba(0,0,0,0.1)">
              <Text bold colorWhite fontSize30 marginTop={spacer.top} center>Portfolio Status</Text>
              <Col width50 height={1} bgWhite alignSelf="center" marginTop={5} />
              <Text bold colorWhite fontSize40 marginTop={5} center>{VarHelper.money(portfolioValue)}</Text>
              <Text colorWhite marginTop5 body1 center>When you trade more with Vintage Acquisitions we will reduce the backend commission.</Text>
              {/* {!!nextCommision && (
                <Text backgroundColor="black" center paddingVertical5 paddingHorizontal10 colorWhite marginTop5 body1>You are curently <Text colorWhite bold fontSize25>{VarHelper.money(nextCommision.range[0] - portfolioValue)}</Text> away from reaching '{nextCommision.name.toUpperCase()} STATUS'</Text>
              )} */}
              <Col height={spacer.middle} />
              {useMemo(() => {
                return page === 'single-cask' ? renderSingleCask() : renderMultipleCasks();
              }, [listClients, page])}
              {/* <Col
                marginTop={spacer.bottom}
                alignSelf="center" bgMain width300 paddingVertical5 middle
                onPress={() => setShowAvailableCask(true)}
              >
                <Text colorWhite body1>CLICK TO SEE AVAILABLE CASKS</Text>
              </Col> */}
            </Col>

            {showAvailableCask && (
              <Col
                absolute top='50%' left='50%'
                transform={[{ translateX: -modalSize * 0.5 }, { translateY: -modalSize * 0.3 }]}
                width={modalSize}
                height={modalSize / 2}
              >
                <Scroll height={modalSize / 2}>
                  <Card
                    title={"Available Casks"} marginBottom20 iconRigth={<ICON.Close fill="white" width={20} height={20} />}
                    iconRightOnPress={() => setShowAvailableCask(false)}
                  >
                    <TableWithAction
                      columns={[
                        { key: 'Distillery', title: 'DISTILLERY', flex: 1, center: true },
                        { key: 'Region', title: 'REGION', flex: 1, center: true },
                        { key: 'Cask Type', title: 'CASK TYPE', flex: 1, center: true },
                        { key: 'Cask number', title: 'CASK#', flex: 1, center: true },
                        { key: 'Age', title: 'AGE', flex: 1, center: true },
                        { key: 'Price', title: 'CASK PRICE', flex: 1, center: true },
                      ]}
                      data={listAvailableCasks}
                      onPressAction={(item, i) => messageAdmin(item)}
                      breakpointToScroll="sm"
                      btnTitle="Request Info"
                    />
                  </Card>
                </Scroll>
              </Col>
            )}
          </Col>
        </Col>
        {height > 600 && width > 800 && <Footer />}
      </>
    </Col>
  );
};

Casks.routeInfo = {
  title: 'Casks',
  path: '/casks',
};

export default Casks;